(() => {
  const init = (root) => {
    if (root.dataset.fgcInitialized === "true") return;
    root.dataset.fgcInitialized = "true";

    const header = root.querySelector("[data-fgc-header]");
    const menuButton = root.querySelector("[data-fgc-menu-button]");
    const mobileMenu = root.querySelector("[data-fgc-mobile-menu]");

    const setMenu = (open) => {
      if (!menuButton || !mobileMenu) return;
      mobileMenu.classList.toggle("is-open", open);
      menuButton.setAttribute("aria-expanded", String(open));
      document.documentElement.style.overflow = open ? "hidden" : "";
    };

    menuButton?.addEventListener("click", () => {
      setMenu(menuButton.getAttribute("aria-expanded") !== "true");
    });
    mobileMenu?.addEventListener("click", (event) => {
      if (event.target.closest("a")) setMenu(false);
    });

    const updateHeader = () => header?.classList.toggle("is-scrolled", window.scrollY > 24);
    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const reveals = root.querySelectorAll("[data-fgc-reveal]");
    if (reducedMotion || !("IntersectionObserver" in window)) {
      reveals.forEach((item) => item.classList.add("is-visible"));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
      );
      reveals.forEach((item) => observer.observe(item));
    }

    root.addEventListener("submit", async (event) => {
      const form = event.target.closest(".fgc-product-card__form");
      if (!form || !window.fetch) return;
      event.preventDefault();

      const button = form.querySelector("button");
      const label = form.querySelector("[data-fgc-add-label]");
      button?.setAttribute("disabled", "");

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error("Unable to add item");

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
        const cart = await cartResponse.json();
        root.querySelectorAll("[data-fgc-cart-count]").forEach((count) => {
          count.textContent = cart.item_count;
        });
        button?.classList.add("is-added");
        if (label) label.textContent = "Added";
        window.setTimeout(() => {
          button?.classList.remove("is-added");
          if (label) label.textContent = "Add";
        }, 1800);
      } catch {
        form.submit();
      } finally {
        button?.removeAttribute("disabled");
      }
    });

    window.requestAnimationFrame(() => root.classList.add("is-ready"));
  };

  const initAll = () => document.querySelectorAll("[data-fgc-storefront]").forEach(init);
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
  initAll();
})();
